import { render, staticRenderFns } from "./action-document-version-form-button.vue?vue&type=template&id=84f483b4&scoped=true"
import script from "./action-document-version-form-button.vue?vue&type=script&lang=js"
export * from "./action-document-version-form-button.vue?vue&type=script&lang=js"
import style0 from "./action-document-version-form-button.vue?vue&type=style&index=0&id=84f483b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f483b4",
  null
  
)

export default component.exports